function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bilingual",
  transform: "translate(-1200.496 -840)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5639",
  "data-name": "Rectangle 5639",
  width: 56,
  height: 56,
  transform: "translate(1200.496 840)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Art",
  transform: "translate(-8.837 80)"
}, /*#__PURE__*/React.createElement("g", {
  id: "language",
  transform: "translate(1211 768)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_60677",
  "data-name": "Path 60677",
  d: "M29.667,48.333A1.667,1.667,0,0,1,28,46.574l1.667-30A1.666,1.666,0,0,1,31.333,15H52.167a5.005,5.005,0,0,1,5,5V43.333a5.005,5.005,0,0,1-5,5Z",
  transform: "translate(-4.667 -9.167)",
  fill: "#f5f5f7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60678",
  "data-name": "Path 60678",
  d: "M6,42.333a5.005,5.005,0,0,1-5-5V14A5.005,5.005,0,0,1,6,9H28.5a1.667,1.667,0,0,1,1.664,1.759l-1.667,30a1.666,1.666,0,0,1-1.664,1.574Z",
  transform: "translate(-0.167 -8.167)",
  fill: "#ff0660"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60679",
  "data-name": "Path 60679",
  d: "M24.861,33.332,19.027,20a1.668,1.668,0,0,0-3.055,0L10.139,33.332a1.667,1.667,0,0,0,3.054,1.337l.657-1.5h7.3l.657,1.5a1.667,1.667,0,0,0,3.054-1.337Zm-9.552-3.5L17.5,24.825l2.192,5.008Z",
  transform: "translate(-1.667 -9.833)",
  fill: "#f5f5f7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60680",
  "data-name": "Path 60680",
  d: "M52.507,39.227c-.977-.57-2.076-1.283-3.167-2.062,2.171-1.985,3.993-4.305,3.993-6.5,0-2.126-1.953-3.653-5-4.057v-.943a1.667,1.667,0,1,0-3.333,0v.943c-3.047.4-5,1.931-5,4.057,0,2.194,1.825,4.516,4,6.5-1.03.737-2.111,1.439-3.172,2.058a1.667,1.667,0,0,0,1.679,2.879,46.992,46.992,0,0,0,4.16-2.753,47.118,47.118,0,0,0,4.16,2.753,1.667,1.667,0,0,0,1.681-2.88Zm-5.842-4.148c-1.9-1.629-3.336-3.272-3.341-4.372.134-.257,1.287-.873,3.343-.873s3.209.616,3.333.833C50,31.73,48.624,33.38,46.664,35.078Z",
  transform: "translate(-6.667 -10.667)",
  fill: "#ff0660"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60681",
  "data-name": "Path 60681",
  d: "M29.162,40.639l1.667-30A2.5,2.5,0,0,0,28.333,8H5.833A5.84,5.84,0,0,0,0,13.833V37.167A5.84,5.84,0,0,0,5.833,43H26.667A2.5,2.5,0,0,0,29.162,40.639Zm-27.5-3.472V13.833A4.171,4.171,0,0,1,5.833,9.667h22.5a.84.84,0,0,1,.607.262.832.832,0,0,1,.226.617l-1.667,30a.834.834,0,0,1-.833.788H5.833A4.171,4.171,0,0,1,1.667,37.167Z",
  transform: "translate(0 -8)",
  fill: "#000072"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60682",
  "data-name": "Path 60682",
  d: "M19.624,19.5a2.5,2.5,0,0,0-4.582,0L9.209,32.832a2.5,2.5,0,0,0,4.582,2l.438-1h6.208l.438,1a2.5,2.5,0,0,0,4.581-2ZM23.5,34.6a.842.842,0,0,1-1.1-.429l-.657-1.5a.834.834,0,0,0-.763-.5h-7.3a.832.832,0,0,0-.763.5l-.657,1.5a.849.849,0,0,1-1.1.43.834.834,0,0,1-.429-1.1L16.57,20.167a.834.834,0,0,1,1.528,0L23.931,33.5A.835.835,0,0,1,23.5,34.6Z",
  transform: "translate(-1.5 -9.667)",
  fill: "#000072"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60683",
  "data-name": "Path 60683",
  d: "M19.16,25.158a.833.833,0,0,0-1.527,0l-2.191,5.008a.833.833,0,0,0,.762,1.167h4.4a.833.833,0,0,0,.686-1.307Zm-1.681,4.508.917-2.1.918,2.1ZM42.562,23a2.5,2.5,0,0,0-2.5,2.5v.236c-3.1.616-5,2.4-5,4.764,0,1.935,1.182,4.086,3.517,6.4-.755.513-1.518.995-2.278,1.439a2.5,2.5,0,1,0,2.52,4.317c.593-.346,2.07-1.234,3.74-2.439,1.67,1.2,3.147,2.093,3.741,2.44a2.5,2.5,0,0,0,2.519-4.32c-.723-.422-1.5-.913-2.274-1.441,2.333-2.317,3.514-4.466,3.514-6.4,0-2.365-1.9-4.148-5-4.764V25.5A2.5,2.5,0,0,0,42.562,23ZM48.4,30.5c0,1.621-1.287,3.656-3.722,5.883a.834.834,0,0,0,.077,1.293c1.09.779,2.207,1.507,3.232,2.1a.833.833,0,0,1,.3,1.139.849.849,0,0,1-1.14.3,46.4,46.4,0,0,1-4.083-2.7.831.831,0,0,0-.994,0,46.128,46.128,0,0,1-4.083,2.7.849.849,0,0,1-1.139-.3.833.833,0,0,1,.3-1.139c1.083-.632,2.171-1.337,3.236-2.1a.834.834,0,0,0,.078-1.293c-2.439-2.228-3.728-4.265-3.728-5.887,0-1.643,1.639-2.881,4.277-3.231a.832.832,0,0,0,.723-.826V25.5a.833.833,0,0,1,1.667,0v.943a.832.832,0,0,0,.723.826C46.756,27.619,48.4,28.857,48.4,30.5Z",
  transform: "translate(-2.562 -10.5)",
  fill: "#000072"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60684",
  "data-name": "Path 60684",
  d: "M43.083,31.321a.837.837,0,0,0-.094.39c0,.468.008,1.89,3.631,5a.834.834,0,0,0,1.088,0c2.4-2.084,3.623-3.78,3.623-5.042a.829.829,0,0,0-.111-.414C50.812,30.538,49.068,30,47.165,30,45.2,30,43.482,30.556,43.083,31.321Zm4.076,3.644a8.935,8.935,0,0,1-2.413-2.891,6.263,6.263,0,0,1,2.419-.407,6.508,6.508,0,0,1,2.4.394A9.685,9.685,0,0,1,47.159,34.965Z",
  transform: "translate(-7.165 -11.667)",
  fill: "#000072"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60685",
  "data-name": "Path 60685",
  d: "M52,14H36.821a.833.833,0,0,0,0,1.667H52a4.171,4.171,0,0,1,4.167,4.167V43.167A4.171,4.171,0,0,1,52,47.333H29.5a.832.832,0,0,1-.832-.879l.041-.741a.833.833,0,0,0-1.664-.093L27,46.362A2.5,2.5,0,0,0,29.5,49H52a5.841,5.841,0,0,0,5.833-5.833V19.833A5.841,5.841,0,0,0,52,14Z",
  transform: "translate(-4.5 -9)",
  fill: "#000072"
}))));

function SvgBilingual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilingual);
export default __webpack_public_path__ + "static/media/bilingual.2629c17b.svg";
export { ForwardRef as ReactComponent };